import { UserType } from "@common/types/user";
import { OrganizationAction } from "@common/userOrganizationRoles";
import { useUser } from "@hooks/useUser";
import { useCanPerformOrganizationAction } from "./useCanPerformOrganizationAction";

/**
 * Returns whether the current user can navigate to the organization billing
 * page. Grants access when:
 *   - the user has the VIEW_ORGANIZATION_BILLING org-role action (admins/owners), OR
 *   - the user is a support user (no org-role membership, but needs read access)
 */
export function useCanViewOrganizationBilling(): boolean {
    const user = useUser();
    const hasRoleAccess = useCanPerformOrganizationAction(
        OrganizationAction.VIEW_ORGANIZATION_BILLING,
    );

    return user.type === UserType.SUPPORT || hasRoleAccess;
}
